module.exports = __webpack_public_path__ + "static/media/profilePhoto.cd6044d9.svg";